import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getResourceTypes: 'materialArea/getResourceTypes',
    }),
  },
  mounted () {
    this.$bus.off("upload_vue", this.onUploaded);
    this.$bus.on("upload_vue", this.onUploaded);
  },
  beforeDestroy () {
    this.$bus.off("upload_vue", this.onUploaded);
  },
  methods: {
    ...mapMutations({
      setChoosedResourceType: 'materialArea/setChoosedResourceType'
    }),
    ...mapActions({
      addUploadedItem: 'resources/addUploadedItem'
    }),
    onUploaded (uploadFileData) {
      let blockedNames = ['imageWatermark'];
      if (blockedNames.includes(uploadFileData.name)) {
        return;
      }
      let whiteList = ['image', 'video', 'audio'];
      if (whiteList.includes(uploadFileData.type)) {
        this.addUserItem(uploadFileData);
      }
    },
    async addUserItem (fileInfo) {
      let { type, data } = fileInfo;
      let cate
      let query
      let cbType
      if (Array.isArray(data) && data.length && type === 'image') {
        type = 'multiImage';
        cbType = 'image';
        query = {
          url: '',
          title: '',
          thumbnailUrl: '',
          fileType: 3
        }
        data.forEach(v => {
          query.url += query.url ? (',' + v.filename) : v.filename;
          query.title += query.title ? (',' + v.title) : v.title;
          query.thumbnailUrl += query.thumbnailUrl ? (',' + v.thumbnailName) : v.thumbnailName;
        });
      }
      if (type === 'video') {
        cbType = 'video';
        if (fileInfo.name === 'videoAndImage') {
          cbType = 'videoBg';
        }
        query = {
          url: fileInfo.data.filename,
          title: fileInfo.file.name,
          thumbnailUrl: fileInfo.fileName,
          duration: fileInfo.duration,
          times: fileInfo.duration,
          fileType: 26
        }
      }
      // record | bgm
      if (type === 'audio') {
        cbType = 'sound';
        type = 'sound',
          cate = fileInfo.name === 'music' ? 'bgm' : 'audioRecord';
        query = {
          duration: fileInfo.duration,
          thumbnailUrl: "",
          times: fileInfo.duration,
          title: fileInfo.file.name,
          url: fileInfo.data.filename,
        }
        if (fileInfo.name === 'audio') {
          query.musicType = 1;
        }
      }
      if (type === 'image') {
        cbType = 'image';
        if (fileInfo.name === 'videoAndImage') {
          cbType = 'imageBg';
        }
        query = {
          thumbnailUrl: data.thumbnailName,
          title: fileInfo.file.name,
          url: fileInfo.data.filename,
        }
      }
      // open mine content
      this.$store.commit('resources/setIsSearchAll', false);
      let tab = this.getResourceTypes.find(v => v.key === 'mine')
      this.setChoosedResourceType(tab);
      let paramType = type;
      // if (type === 'multiImage') {
      //   paramType = 'image';
      // }
      let res = query && await this.addUploadedItem({ type: paramType, ...query });
      if (res.code === 200) {
        if (paramType === 'multiImage') {
          const resp = await this.$http('/api/user/pic?sOfPage=10&fPage=10&pIndex=1')
         let item = resp.data.data.find((item) => {
            return item.thumbnailUrl === query.thumbnailUrl;
          });
          res.data = item;
        }
        this.$bus.emit('uploadFile.addUserItem', {
          type: cbType,
          cate: window.cate,
          ...res
        });
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/mixins/UploadMixin.js